<svelte:options customElement="hb-searchbar" />

<script lang="ts">
  import { onMount } from "svelte";
  import type { Component, TSearchListItem } from "./types/webcomponent.type";

  import Item from "./subcomponents/item.svelte";

  let {
    id = "",
    style,

    value = "",
    input_info,
    searchlabel = "Search",
    searchlist,
    minlength = 0,
    disable_preview = "no",
    textarea,
    disabled,
  }: Component = $props();

  const isDisabled = $derived(disabled === "yes");
  let open: boolean = $state(false);
  let searchlistViewed = $derived(
    searchlist?.filter?.(
      (item: TSearchListItem) =>
        item?.fixed ||
        item?.text?.toLowerCase?.().includes?.(value?.toLowerCase?.()),
    ),
  );
  const isOpen = $derived(
    disable_preview !== "yes" &&
      disable_preview !== "true" &&
      disable_preview !== "on" &&
      value?.length > Number(minlength) &&
      open,
  );
  $effect(() => {
    if (!id) id = "";
    if (!searchlist) searchlist = [];
    if (typeof searchlist === "string") {
      try {
        searchlist = JSON.parse(searchlist);
      } catch (err) {
        console.error("error parsing searchlist", err);
      }
    }
    if (typeof input_info === "string") {
      try {
        input_info = JSON.parse(input_info);
      } catch (err) {
        console.error("error parsing input_info", err);
      }
    }
    // if (!style) style = "";
    // method = method.toUpperCase() as "GET";

    // if (isSearchCleared) {
    //   searchPromise = [];
    // }
    // search(actionQueryValue);
    console.log(value, "value");
  });

  async function searchBy(
    by: "button" | "input" | "searchlist",
    listItemId?: string,
  ) {
    if (isDisabled || !value) return;
    console.log("searching", by, value);
    let searchlistelement: TSearchListItem | undefined;
    if (listItemId) {
      searchlistelement = searchlist?.find(
        (item: any) => item.id === listItemId,
      );
      if (searchlistelement)
        dispatch("search", { input: value, by, item: searchlistelement });
    } else {
      dispatch("search", { input: value, by });
    }
    if (by !== "input") open = false;

    // if (actionQueryValue) {
    //   try {
    //     const here = new URL(window.location.href);

    //     searchResource = new URL(`${server_uri}`);
    //     // perform search with searchResource
    //   } catch (error) {
    //     console.error(searchResource, error);
    //   }

    //   searchInit = {
    //     method,
    //   };
    //   searchPromise = await fetchSearchRes(searchResource.href, searchInit);
    //   showDropdown = "show";
    // } else {
    //   showDropdown = "";
    // }
  }
  let timer: ReturnType<typeof setTimeout> | undefined = $state(undefined);

  function debounce(e: any) {
    if (isDisabled) return;
    open = true;
    if (e.key === "Enter") return;
    console.log("debouncing", value);
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      //     if (!value && actionQueryValue) {
      //       isSearchCleared = true;
      //     } else {
      //       isSearchCleared = false;
      //     }
      //     actionQueryValue = value;
      if (value && (!minlength || value.length > Number(minlength)))
        searchBy("input");
    }, 500);
  }

  function handleSearchButtonClick(e: Event) {
    if (e) e.preventDefault?.();
    console.log("clicked searching");
    searchBy("button");
  }

  /** Mirrors native `input type="search"` clear: empty field and dispatch `clear`. */
  function clearTextareaSearch() {
    value = "";
    dispatch("clear", { id });
    open = false;
  }

  /** Close preview only on clicks outside the host (works with Shadow DOM; avoids closing on textarea resize). */
  function closeDropdown(e: Event) {
    const host = $host();
    const path = typeof e.composedPath === "function" ? e.composedPath() : [];
    const inside =
      path.length > 0
        ? path.includes(host)
        : e.target instanceof Node && host.contains(e.target);
    if (inside) return;
    if (open) open = false;
  }
  onMount(() => {
    console.log("mounting searchbar");
    window.addEventListener("click", closeDropdown);
    return () => {
      console.log("unmounting searchbar");
      window.removeEventListener("click", closeDropdown);
    };
  });
  // async function fetchSearchRes(
  //   resource: string,
  //   init: any,
  // ): Promise<object[]> {
  //   console.log("fetching search results");
  //   const res = await fetch(resource, init);
  //   const data = await res.json();

  //   if (res.ok) {
  //     dispatch("results", data);
  //     return data;
  //   } else {
  //     dispatch("results", new Error(data));
  //     throw new Error(data);
  //   }
  // }

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@latest/font/bootstrap-icons.css"
  />
</svelte:head>
<div
  class="hb-searchbar-root is-relative"
  class:hb-searchbar-root--open={isOpen}
>
  <div
    class="field mb-0 hb-searchbar-field"
    class:hb-searchbar-field--textarea={textarea === "yes" ||
      textarea === "true" ||
      textarea === ""}
  >
    <div
      class="control is-expanded hb-searchbar-input-wrap"
      class:hb-searchbar-input-wrap--with-clear={!!value &&
        (textarea === "yes" || textarea === "true" || textarea === "")}
    >
      <!-- Frosted layer: always painted (no opacity:0); opaque input covers it until :focus. -->
      <div
        class="hb-searchbar-input-glass"
        part="search-input-glass"
        aria-hidden="true"
      ></div>
      {#if textarea === "yes" || textarea === "true" || textarea === ""}
        <textarea
          id="custom-search-input"
          part="search-input"
          bind:value
          class="input"
          autocomplete="off"
          placeholder={searchlabel}
          aria-label="Search"
          aria-describedby="search"
          disabled={isDisabled}
          oninput={debounce}
          onkeypress={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              searchBy("button");
            }
          }}
        >
        </textarea>
      {:else}
        <input
          id="custom-search-input"
          part="search-input"
          bind:value
          class="input"
          type="search"
          autocomplete="off"
          placeholder={searchlabel}
          aria-label="Search"
          aria-describedby="search"
          disabled={isDisabled}
          oninput={debounce}
          onkeypress={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              searchBy("button");
            }
          }}
          onsearch={(e: any) => {
            console.log("SEEEEEEEEE", e.target.value);
            if (e.target?.value === "") {
              dispatch("clear", { id });
              open = false;
            }
          }}
        />
      {/if}
      <div class="hb-searchbar-trailing-actions">
        {#if value && (textarea === "yes" || textarea === "true" || textarea === "")}
          <!-- svelte-ignore a11y_consider_explicit_label -->
          <button
            class="button is-ghost is-small hb-searchbar-clear"
            type="button"
            aria-label="Clear search"
            disabled={isDisabled}
            onclick={clearTextareaSearch}
          >
            <i class="bi bi-x-lg" aria-hidden="true"></i>
          </button>
        {/if}
        <!-- svelte-ignore a11y_consider_explicit_label -->
        <button
          type="button"
          class="hb-searchbar-search-trigger"
          part="search-submit"
          aria-label="Search"
          disabled={isDisabled}
          onclick={handleSearchButtonClick}
        >
          <i class="bi bi-search" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="dropdown hb-searchbar-dropdown" class:is-active={isOpen}>
    <div class="dropdown-menu" part="dropdown-menu" id="custom-search-list">
      <div class="dropdown-content hb-searchbar-dropdown-content">
        {#if input_info && input_info.text === value}
          <Item
            clicksearch={async (text: string, id?: string) => {
              if (id) {
                value = text as string;
                searchBy("searchlist", id);
              } else {
                searchBy("button");
              }
            }}
            id={input_info.id}
            is_inpput={true}
            icon={input_info.icon}
            badge={input_info.badge}
            text={input_info.text}
            input_search={value}
            url={input_info.url}
            number_of_results={input_info.number_of_results}
          />
        {:else}
          <button
            type="button"
            class="hb-searchbar-row"
            onclick={() => {
              searchBy("button");
            }}>... {value}</button
          >
        {/if}

        {#if searchlistViewed?.length}
          <p class="hb-searchbar-section-label">Suggested results</p>

          {#each searchlistViewed as item (item.id)}
            <Item
              clicksearch={async (text: string, id?: string) => {
                if (id) {
                  value = text as string;
                  searchBy("searchlist", id);
                } else {
                  searchBy("button");
                }
              }}
              id={item.id}
              is_inpput={false}
              icon={item.icon}
              badge={item.badge}
              text={item.text}
              input_search={value}
              url={item.url}
              number_of_results={item.number_of_results}
            />
          {/each}
        {/if}
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
